module.exports = __webpack_public_path__ + "img/yellow.a4ee483f.gif";